/**
 * Determines if screen size is less than 1024
 *
 * @returns {boolean} - true/false
 */
const isMobile = () => window.innerWidth < 1024;

export default isMobile;

/**
 * Determines if screen size is less than small (320)
 *
 * @returns {boolean} - true/false
 */
const isXS = () => window.innerWidth <= 320;

export {isXS};

/**
 * Determines if screen height is less than small (420)
 *
 * @returns {boolean} - true/false
 */
const isSmallContent = () => window.innerHeight <= 420;

export {isSmallContent};
